<template>
    <el-dialog
            :visible.sync="showModel"
            :modal="isModal"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modalAppendToBody="false"
            :append-to-body="appendToBody"
            custom-class="registerDialog">

        <div class="container">
            <el-image :src="icon" fit="cover" />
            <div class="outer-content mt-2">{{outerContent}}</div>
            <div class="main-content">
                <span>您要轉贈的對象是</span>
                <span class="red">{{name}}</span>
                <span>嗎？</span>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" round v-show="isCancel" type="info">{{negativeLabel}}</el-button>
                <el-button @click="confirm" round type="primary">{{positiveLabel}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "RegisterDialog",
        props: {
            icon: {default: require('@/assets/images/member2.svg')},
            outerContent: {default: "提醒"},
            positiveLabel: {default: "確定"},
            negativeLabel: {default: "取消"},
            value: {required: false, type: Boolean, default: false},        //是否顯示 dialog (dialog開關)?
            eventType: {required: false, type: Number, default: 0},            //事件種類辨認用，會在 result 中回傳，可以在顯示 dialog前設定好，在 result中以此來辨認目前是哪個事件的 result
            isCancel: {default: true},
            isModal: {default: true},
            name: {default: '--'},
            appendToBody:{default: false},
        },
        data() {
            return {
                showModel: this.value,  //是否顯示 dialog
            }
        },
        created() {

        },
        mounted() {

        },
        watch: {
            value: function () {
                this.showModel = this.value;
            }
        },
        methods: {
            cancel: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                // args1 : 是否確定？
                // args2 : 事件類型
                this.$emit('result', false, this.eventType);
            },
            confirm: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                this.$emit('result', true, this.eventType);
            }
        }
    }
</script>